import { Component, OnInit, Input } from "@angular/core";
import { AdminAuthService } from "../../../admin/services/admin-auth.service";
import { ScholarAuthService } from "../../../scholar/services/scholar-auth.service";
import { MentorAuthService } from "../../../mentor/services/mentor-auth.service";
import { Router } from "@angular/router";
import {
  trigger,
  transition,
  style,
  animate,
  query,
  stagger,
} from "@angular/animations";
import { Observable, Subject } from "rxjs";
import { ScholarService } from "src/app/scholar/services/scholar.service";
export const titleAnimation = trigger("titleAnimation", [
  transition(":enter", [
    style({ opacity: 0 }),
    animate("600ms ease", style({ opacity: 1 })),
  ]),
  transition(":leave", [
    style({ opacity: 1 }),
    animate("800ms", style({ opacity: 0 })),
  ]),
]);

const listAnimation = trigger("listAnimation", [
  transition("* <=> *", [
    query(
      ":enter",
      [
        style({ opacity: 0 }),
        stagger("100ms", animate("600ms ease-out", style({ opacity: 1 }))),
      ],
      { optional: true }
    ),
    query(
      ":leave",
      animate(
        "500ms ease-in",
        style({ opacity: 0, display: "none", transform: "translateX(100px)" })
      ),
      {
        optional: true,
      }
    ),
  ]),
]);
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
  animations: [titleAnimation, listAnimation],
})
export class HeaderComponent implements OnInit {
  constructor(
    private adminAuthService: AdminAuthService,
    private route: Router,
    private scholarAuthService: ScholarAuthService,
    private mentorAuthService: MentorAuthService,
    private router: Router,
    private scholarService: ScholarService
  ) {}
  show = true;
  items: any[] = [];
  isToggle = false;
  @Input() type = "Scheduled tasks";
  @Input() message = "with mentor";
  @Input() closeable = true;
  @Input() fullWidth = false;
  @Input() sideNav;
  @Input() title;
  userName = "";
  badgeCount: number;
  mentorName: string;
  ngOnInit() {
    if (this.title === "Co-ordinator") {
      this.userName = this.adminAuthService.getUserName();
    } else if (this.title === "Scholar") {
      this.userName = this.scholarAuthService.getUserName();
      // this.scholarService
      //   .getTaskNotifications(this.scholarAuthService.getLoggedUserId())
      //   .subscribe((data: any) => {
      //     const { mentorId, meetings } = data;
      //     this.mentorName = `${mentorId.personalDetails.firstName} ${mentorId.personalDetails.lastName}`;
      //     this.items=meetings;
      //     this.badgeCount = meetings.length;
      //   });
      this.scholarService
        .getTaskNotifications(this.scholarAuthService.getLoggedUserId())
        .subscribe(
          (data: any) => {
            // Check if mentorId is not null or undefined before accessing its properties
            if (data && data.mentorId) {
              const { mentorId, meetings } = data;
              this.mentorName = `${mentorId.personalDetails.firstName} ${mentorId.personalDetails.lastName}`;
              this.items = meetings;
              this.badgeCount = meetings.length;
            } else {
              this.mentorName ="No mentor assigned yet.";
              this.items = [];
              this.badgeCount = 0;
            }
          },
          (error) => {
            // Handle the error from the API call if necessary
            console.error("Error fetching task notifications:", error);
            // Set default values or display an error message
            this.mentorName = "No mentor assigned yet.";
            this.items = [];
            this.badgeCount = 0;
          }
        );
    } else if (this.title === "Mentor") {
      this.userName = this.mentorAuthService.getUserName();
    }
  }
  close() {
    this.show = false;
  }
  setting() {
    return {
      fullwidth: this.fullWidth,
    };
  }
  logout() {
    if (this.title === "Co-ordinator") {
      this.adminAuthService.logout();
      this.route.navigate(["/"]);
    } else if (this.title === "Scholar") {
      this.scholarAuthService.logout();
      this.route.navigate(["/"]);
    } else if (this.title === "Mentor") {
      this.mentorAuthService.logout();
      this.route.navigate(["/"]);
    }
  }

  showNotifications() {
    this.isToggle = !this.isToggle;
  }
  removeThis(index, event: Event) {
    event.stopPropagation();
    this.items.splice(index, 1);
    this.badgeCount = this.items.length;
  }
}
